import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../state/useAuth';
import { pb, getFileUrl } from '../../../lib/pb';

export default function WorkerDocuments() {
  const { model: user } = useAuth();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    setLoading(true);
    try {
      const res = await pb.collection('assignments').getFullList({
        filter: `user = "${user.id}"`,
        expand: 'chantier',
        sort: '-start_date'
      });
      // Flatten all attachments from all assigned chantiers
      const allDocs = [];
      for (const a of res) {
        const ch = a.expand?.chantier;
        if (ch && ch.attachments?.length) {
          for (const f of ch.attachments) {
            allDocs.push({ file: f, chantier: ch, chantierId: ch.id });
          }
        }
      }
      setDocs(allDocs);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { fetch(); }, [fetch]);

  const ext = (name) => name.split('.').pop()?.toLowerCase();
  const isImg = (name) => ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext(name));
  const isPdf = (name) => ext(name) === 'pdf';

  return (
    <div>
      <div className="w-page-header">
        <div>
          <h1 className="w-page-title">Documents</h1>
          <p className="w-page-subtitle">Plans, bons & fichiers de vos chantiers</p>
        </div>
      </div>

      <div style={{ padding: '16px' }}>
        {loading && <div className="w-loading"><div className="w-spinner" /></div>}

        {!loading && docs.length === 0 && (
          <div className="w-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
            </svg>
            <h3>Aucun document</h3>
            <p>Les plans partagés par votre responsable apparaîtront ici.</p>
          </div>
        )}

        {!loading && docs.map((d, i) => (
          <a
            key={i}
            href={getFileUrl(d.chantier, d.file)}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <div className="w-card" style={{ marginBottom: 10, display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px' }}>
              {/* Icon */}
              <div style={{
                width: 46, height: 46, borderRadius: 14, flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: isPdf(d.file) ? '#fef2f2' : isImg(d.file) ? '#eff6ff' : '#f8fafc',
              }}>
                {isPdf(d.file) ? (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                ) : isImg(d.file) ? (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                ) : (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                )}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--w-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {d.file}
                </div>
                <div style={{ fontSize: 12, color: 'var(--w-muted)', marginTop: 2 }}>
                  {d.chantier.title}
                </div>
              </div>

              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
